export const customerDetailsStep1Defaults = {
  outletName: "",
  companyGST: "",
  companyPAN: "",
  registeredAddress: "",
  authorizedSignatory: "",
  vatNumber: "",
  state: "",
  pincode: "",
  emailID: "",
  gstStateCode: "",
  comp_gst_cert: {},
  comp_pan_card: {},
  comp_vat_cert: {},
  phoneNumber: "",
};

export const customerDetailsStep2Defaults = {
  licenseName: "",
  licenseType: "",
  customerExciseRegistrationNumber: "",
  licensePAN: "",
  licenseGST: "",
  licenseAddress: "",
  gstStateCode: "",
  lic_rvb_license: {},
  lic_license_pan: {},
  lic_gst_cert: {},
};

export const customerDetailsStep3Defaults = {
  bankName: "",
  bankBranch: "",
  accountType: "",
  accountNumber: "",
  ifscCode: "",
  beneficiaryName: "",
  accountsDepartmentPOCName: "",
  accountsDepartmentPOCNumber: "",
  bank_cancelled_cheque: {},
};
